import { render } from "./Emotions.vue?vue&type=template&id=6a34871e"
import script from "./Emotions.vue?vue&type=script&lang=js"
export * from "./Emotions.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__